export default __webpack_public_path__ + "static/media/img13.8bb7ee9b.png";